// extracted by mini-css-extract-plugin
export default {"tableRow":"TableRow_tableRow__-evGL","true":"TableRow_true__3ifez","rowItem":"TableRow_rowItem__u3vDf","isHeader":"TableRow_isHeader__VNjdX"};